import { BaseEntity } from "yt-ng-framework";

export class UserProvajder extends BaseEntity{
    constructor(){
        super();
    }

   // ID: number = null
    UserId: number = null;
    FirmaID: number = null;
    SefProvajderId: number = null;
    Username: string = null;
    Password: string = null;
    ApiKey: string = null;
    DocloopSoftwareId: string = null;
    IsActive: boolean = false;
    OrgJedId: number = null;
    EOtpremnicaApiKey: string = null;
    EotprProvajderId: number = null;

    Deserialize(input: any){
        super.Deserialize(input);
        this.ID = input.ID;
        this.UserId = input.UserId;
        this.FirmaID = input.FirmaID;
        this.SefProvajderId = input.SefProvajderId;
        this.Username = input.Username;
        this.Password = input.Password;
        this.ApiKey = input.ApiKey;
        this.DocloopSoftwareId = input.DocloopSoftwareId;
        this.IsActive = input.IsActive;
        this.EOtpremnicaApiKey = input.EOtpremnicaApiKey;
        this.EotprProvajderId = input.EotprProvajderId;
        return this;
    }

    Serialize(input: UserProvajder): {} {
        return input;
    }
}